export default __webpack_public_path__ + "static/media/pinkFlowerBush.68935fba.jpg";